import styled from "styled-components";

export const Container = styled.div`
  position: relative;
`;

export const ChildrenTableContainer = styled.div`
  grid-column: 1 / span 2;
`;
